/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ImportedTestCase } from './ImportedTestCase';
import {
    ImportedTestCaseFromJSON,
    ImportedTestCaseFromJSONTyped,
    ImportedTestCaseToJSON,
    ImportedTestCaseToJSONTyped,
} from './ImportedTestCase';
import type { CodeLanguage } from './CodeLanguage';
import {
    CodeLanguageFromJSON,
    CodeLanguageFromJSONTyped,
    CodeLanguageToJSON,
    CodeLanguageToJSONTyped,
} from './CodeLanguage';

/**
 * One problem merged by name from the round's files, before AI formatting.
 * @export
 * @interface ImportedProblemDraft
 */
export interface ImportedProblemDraft {
    /**
     * 
     * @type {string}
     * @memberof ImportedProblemDraft
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ImportedProblemDraft
     */
    ordinal: number;
    /**
     * 
     * @type {number}
     * @memberof ImportedProblemDraft
     */
    points: number | null;
    /**
     * 
     * @type {number}
     * @memberof ImportedProblemDraft
     */
    time_limit: number | null;
    /**
     * 
     * @type {string}
     * @memberof ImportedProblemDraft
     */
    marked_text?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ImportedProblemDraft
     */
    images?: { [key: string]: string; };
    /**
     * 
     * @type {Array<string>}
     * @memberof ImportedProblemDraft
     */
    warnings: Array<string>;
    /**
     * 
     * @type {Array<ImportedTestCase>}
     * @memberof ImportedProblemDraft
     */
    test_cases?: Array<ImportedTestCase>;
    /**
     * 
     * @type {string}
     * @memberof ImportedProblemDraft
     */
    solution_code?: string | null;
    /**
     * 
     * @type {CodeLanguage}
     * @memberof ImportedProblemDraft
     */
    solution_language?: CodeLanguage | null;
}



/**
 * Check if a given object implements the ImportedProblemDraft interface.
 */
export function instanceOfImportedProblemDraft(value: object): value is ImportedProblemDraft {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('ordinal' in value) || value['ordinal'] === undefined) return false;
    if (!('points' in value) || value['points'] === undefined) return false;
    if (!('time_limit' in value) || value['time_limit'] === undefined) return false;
    if (!('warnings' in value) || value['warnings'] === undefined) return false;
    return true;
}

export function ImportedProblemDraftFromJSON(json: any): ImportedProblemDraft {
    return ImportedProblemDraftFromJSONTyped(json, false);
}

export function ImportedProblemDraftFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportedProblemDraft {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'ordinal': json['ordinal'],
        'points': json['points'],
        'time_limit': json['time_limit'],
        'marked_text': json['marked_text'] == null ? undefined : json['marked_text'],
        'images': json['images'] == null ? undefined : json['images'],
        'warnings': json['warnings'],
        'test_cases': json['test_cases'] == null ? undefined : ((json['test_cases'] as Array<any>).map(ImportedTestCaseFromJSON)),
        'solution_code': json['solution_code'] == null ? undefined : json['solution_code'],
        'solution_language': json['solution_language'] == null ? undefined : CodeLanguageFromJSON(json['solution_language']),
    };
}

export function ImportedProblemDraftToJSON(json: any): ImportedProblemDraft {
    return ImportedProblemDraftToJSONTyped(json, false);
}

export function ImportedProblemDraftToJSONTyped(value?: ImportedProblemDraft | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'ordinal': value['ordinal'],
        'points': value['points'],
        'time_limit': value['time_limit'],
        'marked_text': value['marked_text'],
        'images': value['images'],
        'warnings': value['warnings'],
        'test_cases': value['test_cases'] == null ? undefined : ((value['test_cases'] as Array<any>).map(ImportedTestCaseToJSON)),
        'solution_code': value['solution_code'],
        'solution_language': CodeLanguageToJSON(value['solution_language']),
    };
}

